export default [
  {
    path: "/payrolls",
    name: "payrolls-list",
    meta: {
      title: "Выплаты сотрудникам",
      authRequired: true,
    },
    component: () => import("@/modules/payrolls/views/items.vue"),
  },
];
